"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_HLQA_TASKS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_HLQA_TASKS = (0, gql_1.gql)(`
  query HLQATasksList(
    $catalogId: ID!,
    $productTreeId: ID!,
    $filter: PriorityTasksFilter,
    $sort: [PriorityTasksOrderBy!],
    $before: ID,
    $after: ID,
    $first: Int,
    $last: Int
  ) {
    catalog(id: $catalogId) {
      priorityTasks(productTreeId: $productTreeId, filter: $filter, sort: $sort, before: $before, after: $after, first: $first, last: $last) {
        edges {
          node {
            lastReviewedAt
            status
            escalationReason
            task
            productLabelValidationId
            productTreeNodeId
            label
            priority
            instructions
            assignedTo
            nodeTitle
            totalProducts
            productsReviewed
            percentReviewed
            taskCount
            instructionsUpdatedAt
            l1NodeId
            l1NodeTitle
            reviewedBy
            correctionEventsCount
            correctionsPercent
            totalCorrectionsPercent
            notApplicable
            unknown
          }
        }
        pageInfo {
          hasNextPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  }
`);
